import React from 'react';
import { RecentChatsList } from '../components/Pleri/components/ChatBox/RecentChatsList';

export const ConversationsPage: React.FC = () => {
  return (
    <div className="mx-auto flex h-full w-full max-w-4xl flex-col bg-white dark:bg-gray-900">
      {/* Content - Using the same component as sidebar */}
      <RecentChatsList size="full" showSourceFilter={true} />
    </div>
  );
};
